import { render, staticRenderFns } from "./ModalUpload.vue?vue&type=template&id=cc33d8a0"
import script from "./ModalUpload.vue?vue&type=script&lang=ts"
export * from "./ModalUpload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports